var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorDepartureArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 14,
    viewBox: "0 0 25 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.62 4.9099L19.75 0.9999C19.657 0.906171 19.5464 0.831777 19.4246 0.781008C19.3027 0.73024 19.172 0.704102 19.04 0.704102C18.908 0.704102 18.7773 0.73024 18.6554 0.781008C18.5336 0.831777 18.423 0.906171 18.33 0.9999C18.1437 1.18726 18.0392 1.44071 18.0392 1.7049C18.0392 1.96909 18.1437 2.22254 18.33 2.4099L21.89 5.9999H1.5C1.23478 5.9999 0.98043 6.10526 0.792893 6.29279C0.605357 6.48033 0.5 6.73468 0.5 6.9999H0.5C0.5 7.26512 0.605357 7.51947 0.792893 7.70701C0.98043 7.89454 1.23478 7.9999 1.5 7.9999H21.95L18.33 11.6099C18.2363 11.7029 18.1619 11.8135 18.1111 11.9353C18.0603 12.0572 18.0342 12.1879 18.0342 12.3199C18.0342 12.4519 18.0603 12.5826 18.1111 12.7045C18.1619 12.8263 18.2363 12.9369 18.33 13.0299C18.423 13.1236 18.5336 13.198 18.6554 13.2488C18.7773 13.2996 18.908 13.3257 19.04 13.3257C19.172 13.3257 19.3027 13.2996 19.4246 13.2488C19.5464 13.198 19.657 13.1236 19.75 13.0299L23.62 9.1499C24.1818 8.5874 24.4974 7.8249 24.4974 7.0299C24.4974 6.2349 24.1818 5.4724 23.62 4.9099Z",
    fill: "#221A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorDepartureArrow);
export default __webpack_public_path__ + "static/media/Vector-departure-arrow.9f953e1848c3464c07b2a903dfa9be26.svg";
export { ForwardRef as ReactComponent };